import { preExchangeOperationStartAction } from "../../../Actions/LogicActions/QuickExchange/PreExchangeOperationStartAction";
import { _eventBus } from "../../../core/events/EventBus";
import { StepDefinition } from "../../../core/flows/StepDefinition";
import { StepFlow } from "../../../core/flows/StepFlow";
import { isActionRunSuccessfully } from "../../../Lib/Utils/validationUtil";
import { bookingTree } from "../../../Orchestrator/ConstantTree";
import { IPreExchangeOperationStartParams } from "../../../Orchestrator/Types/Interface/ActionParams/SearchBookingParams";
import { TicketOptionContext } from "../../TrainOfferPage/TicketOptionFlow/Context/TicketOptionContext";
import { QuickExchangeContext } from "../Context/QuickExchangeContext";

class QuickExchangeNextPrevStep extends StepFlow {
    get stepName() { return "QuickExchangeNextPrev_Step"; }

    async onEventSetup(): Promise<void> {
        this.registerEventSubscription(
            _eventBus.on<IPreExchangeOperationStartParams, void>({
                eventName: bookingTree.QuickExchange.Next.Click,
                handler: async ({ data }) => {
                    let context = this.getCtx<QuickExchangeContext>("quickExchangeContext")
                    if (context && data) {
                        preExchangeOperationStartAction.setParams({
                            nextAndPreviousTrain: data.nextAndPreviousTrain,
                            nextTrainTicket: data.nextTrainTicket,
                            type: data.type,
                            trip: data.trip,
                            exchangeOfferPassengerRefs: data.exchangeOfferPassengerRefs
                        })
                        await preExchangeOperationStartAction.execute()
                        if (isActionRunSuccessfully(preExchangeOperationStartAction)) {
                            let ticketOptionContext = this.getCtx<TicketOptionContext>("ticketOptionContext")!;
                            if (ticketOptionContext) ticketOptionContext.isAnonymous = false
                            // context.nextTo = ["CheckoutFlow"]
                            this.next()
                        }
                    }
                }
            })
        )
        /**
         * This event used to close flow
        */
        _eventBus.on<void, void>({
            eventName: bookingTree.QuickExchange.Flow.Close,
            handler: async (payload) => {
                const context = this.getCtx<QuickExchangeContext>("quickExchangeContext")!
                if (context) {
                    context.nextTo = ["RetrieveBooking"];
                    this.next()
                }
            }
        })
    }

    async onExecute(): Promise<void> {
        console.log("Quick exchange flow executing..............")
    }
}

export const quickExchangeNextPrevStepDeclaration = new StepDefinition({
    stepName: "QuickExchangeNextPrev_Step",
    stepClass: QuickExchangeNextPrevStep
});